import React from 'react';

const TYPES = [
  {
    key: 'restaurant',
    label: 'Restaurant',
    sub: 'Select table and place order',
    bg: '#eef4ff',
    border: '#c7d8f7',
    color: '#3366cc',
    icon: (
      <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
        <circle cx="24" cy="24" r="24" fill="#3366cc" />
        <g transform="translate(12,12)" stroke="#fff" strokeWidth="2" strokeLinecap="round">
          <line x1="4" y1="2" x2="4" y2="12" />
          <line x1="4" y1="12" x2="4" y2="22" />
          <line x1="1" y1="2" x2="1" y2="7" />
          <line x1="7" y1="2" x2="7" y2="7" />
          <line x1="1" y1="7" x2="7" y2="7" />
          <line x1="17" y1="2" x2="17" y2="22" />
          <path d="M14 2 C14 2, 13 10, 17 10" />
          <path d="M20 2 C20 2, 21 10, 17 10" />
        </g>
      </svg>
    ),
  },
  {
    key: 'room-service',
    label: 'Room Service',
    sub: 'Select room and place order',
    bg: '#eefbee',
    border: '#b5e5b5',
    color: '#22a352',
    icon: (
      <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
        <circle cx="24" cy="24" r="24" fill="#22a352" />
        <g transform="translate(11,11)" fill="#fff">
          <path d="M13 3 L24 12 H2 Z" />
          <rect x="5" y="12" width="16" height="12" rx="1" />
          <rect x="10" y="16" width="6" height="8" rx="0.5" fill="#22a352" />
        </g>
      </svg>
    ),
  },
  {
    key: 'takeaway',
    label: 'Takeaway',
    sub: 'Quick takeaway order',
    bg: '#fff5eb',
    border: '#f5d0a3',
    color: '#e67e22',
    icon: (
      <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
        <circle cx="24" cy="24" r="24" fill="#e67e22" />
        <g transform="translate(12,10)" fill="#fff">
          <rect x="2" y="0" width="20" height="26" rx="3" fill="none" stroke="#fff" strokeWidth="2" />
          <rect x="6" y="6" width="12" height="2" rx="1" />
          <rect x="6" y="11" width="12" height="2" rx="1" />
          <rect x="6" y="16" width="8" height="2" rx="1" />
          <path d="M15 18 L19 22 L23 14" stroke="#fff" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round" />
        </g>
      </svg>
    ),
  },
];

const ORDER_TYPE_KEY_MAP = {
  IN_ROOM_DINING: 'restaurant',
  ROOM_SERVICE: 'room-service',
  TAKE_AWAY: 'takeaway',
};

export default function ServiceTypeSelector({ onSelect, mode = 'kot', allowedTypes }) {
  let types = TYPES.map(t => (mode === 'bar' && t.key === 'restaurant') ? { ...t, label: 'Bar Counter' } : t);
  if (Array.isArray(allowedTypes) && allowedTypes.length > 0) {
    const allowed = new Set(allowedTypes.map(k => ORDER_TYPE_KEY_MAP[k]).filter(Boolean));
    types = types.filter(t => allowed.has(t.key));
  }
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '60vh', padding: '2rem 1rem' }}>
      <h2 style={{ fontSize: '1.5rem', fontWeight: 700, marginBottom: '0.25rem' }}>Select Service Type</h2>
      <p style={{ color: '#888', marginBottom: '2rem', fontSize: '0.95rem' }}>Choose how you want to place the order</p>
      <div style={{ display: 'flex', gap: '1.5rem', flexWrap: 'wrap', justifyContent: 'center' }}>
        {types.map((t) => (
          <div
            key={t.key}
            onClick={() => onSelect(t.key)}
            style={{
              width: 220,
              padding: '2rem 1.25rem',
              borderRadius: 16,
              border: `1.5px solid ${t.border}`,
              background: t.bg,
              cursor: 'pointer',
              textAlign: 'center',
              transition: 'box-shadow 0.15s, transform 0.15s',
            }}
            onMouseEnter={(e) => { e.currentTarget.style.boxShadow = '0 6px 24px rgba(0,0,0,0.1)'; e.currentTarget.style.transform = 'translateY(-2px)'; }}
            onMouseLeave={(e) => { e.currentTarget.style.boxShadow = 'none'; e.currentTarget.style.transform = 'none'; }}
          >
            <div style={{ marginBottom: '1rem' }}>{t.icon}</div>
            <div style={{ fontWeight: 700, fontSize: '1.05rem', marginBottom: '0.25rem' }}>{t.label}</div>
            <div style={{ color: '#888', fontSize: '0.85rem' }}>{t.sub}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
